import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

/**
 * Ask's compact shell: the app menu and the chats drawer, for widths where the page is one
 * column. The bar opens both; the rail and the layout each own one, and this is what they share.
 */
const AskShellContext = createContext({
    openAppNav: () => {},
    closeAppNav: () => {},
    appNavOpen: false,
    openChats: () => {},
    closeChats: () => {},
    chatsOpen: false,
});

export function AskShellProvider({ children, appNavOpen, onAppNavOpen, onAppNavClose }) {
    const [chatsOpen, setChatsOpen] = useState(false);

    const openAppNav = useCallback(() => onAppNavOpen?.(), [onAppNavOpen]);
    const closeAppNav = useCallback(() => onAppNavClose?.(), [onAppNavClose]);
    const openChats = useCallback(() => setChatsOpen(true), []);
    const closeChats = useCallback(() => setChatsOpen(false), []);

    const value = useMemo(
        () => ({
            openAppNav,
            closeAppNav,
            appNavOpen: Boolean(appNavOpen),
            openChats,
            closeChats,
            chatsOpen,
            setChatsOpen,
        }),
        [openAppNav, closeAppNav, appNavOpen, openChats, closeChats, chatsOpen],
    );

    return <AskShellContext.Provider value={value}>{children}</AskShellContext.Provider>;
}

export function useAskShell() {
    return useContext(AskShellContext);
}

export default AskShellContext;
